module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "content-class": "view-post-modal",
      "max-width": "1200px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.postData !== null) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "text-no-wrap font-weight-bold"
        }, on), [_vm._v(_vm._s(_vm.postData.campaignName) + " Campaign")])]
      }
    }], null, false, 4264487728)
  }, [_vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('span', [_vm._v("Submitted as "), _c('strong', [_vm._v(_vm._s(_vm.postData.submittedCampaignName || _vm.postData.campaignName + ' (Unverified)'))])]) : _vm._e()])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-post-modal__body",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.postHistoryData.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.viewPostDetails()
      }
    }
  }, [_vm._v("\n              Details\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [(_vm.postAbuseHistory && _vm.postHistoryData.length > 0) ? _c('v-col', {
    attrs: {
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-flex', [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n                  Draft History\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.postHistoryData), function(hpost, i) {
    return [_c('v-list-item', {
      key: hpost._id + i,
      on: {
        "click": function($event) {
          return _vm.switchPostView(hpost)
        }
      }
    }, [_c('v-list-item-content', [(hpost.editedBy) ? _c('v-list-item-title', [_vm._v("\n                            " + _vm._s(hpost.editedBy.name) + "\n                          ")]) : _vm._e(), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                            " + _vm._s(hpost.isMain == null ? ((_vm.formatDate(hpost.createdAt)) + " (Active)") : _vm.formatDate(hpost.createdAt)) + "\n                          ")]), _vm._v(" "), (hpost.abuse_resolved) ? _c('v-list-item-title', [_vm._v("\n                            (Pending Abuse Resolved)\n                          ")]) : _vm._e()], 1), _vm._v(" "), (hpost._id === _vm.postData._id) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), (hpost._id !== _vm.postData._id && hpost._id === _vm.post.mainPost._id) ? _c('v-list-item-action', [_c('v-tooltip', {
      attrs: {
        "float-right": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey"
            }
          }, on), [_vm._v("check_circle_outline")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Influencer & Client will see this version of draft.")])])], 1) : _vm._e()], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.setPrimaryPost(_vm.postData._id)
      }
    }
  }, [_vm._v("\n                        Change to this version\n                      ")])], 1), _vm._v(" "), (_vm.postData.status <= _vm.postStatusConfig.CLIENT_PENDING && _vm.postData.abuse_resolved && _vm.saleActions) ? _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticClass: "success",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.releaseAbuseResolvedPosts([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                        Release to Client\n                        "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("done_all")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": _vm.mainViewGrid,
      "xs": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [(_vm.influencerData && !_vm.mappedInfluencerData) ? _c('div', [_c('div', [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.influencers && _vm.postData.influencers.length > 1 && this.currentUserRole <= _vm.userRoles.AD_STRATEGIST) ? _c('div', [(_vm.postData.defaultInf) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [(_vm.postData.defaultInf.tiktok) ? _c('a', {
          attrs: {
            "href": 'https://www.tiktok.com/@' + _vm.postData.defaultInf.handle,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(_vm.postData.defaultInf.handle))]) : (_vm.postData.defaultInf.youtube) ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/' + _vm.postData.defaultInf.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.postData.defaultInf.handle))], 1) : _c('a', {
          attrs: {
            "href": 'https://instagram.com/' + _vm.postData.defaultInf.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.postData.defaultInf.handle))], 1), _vm._v(" "), _c('v-icon', {
          staticClass: "ml-2",
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("mdi-chevron-down-circle")])], 1)]
      }
    }], null, false, 316165323)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postData.influencers), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePlatform(obj, i)
        }
      }
    }, [_c('v-list-item-title', [(obj.tiktok) ? _c('a', [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
  }), 1)], 1) : _vm._e()], 1) : _c('div', [(_vm.influencerData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'xiaohongshu') ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + _vm.influencerData.username)
      }
    }
  }, [_vm._v(_vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)])]), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.type) ? _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [(_vm.getPostTypeMeta(_vm.postData.type).imgIcon) ? _c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.getPostTypeMeta(_vm.postData.type).imgIcon,
      "width": "15px",
      "height": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('v-icon', {
    staticClass: "mr-1",
    style: (("color: " + (_vm.getPostTypeMeta(_vm.postData.type).iconColor || '#ffffff') + " !important;")),
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.getPostTypeMeta(_vm.postData.type).icon))]), _vm._v("\n                          " + _vm._s(_vm._f("platformDisplayName")(_vm.postData.type)) + "\n                        ")], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "0",
            "padding": "0",
            "margin-left": "-5px"
          },
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', _vm._g({
          staticClass: "ml-2",
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, on), [_vm._v("mdi-chevron-down-circle")])], 1)]
      }
    }], null, false, 970486711)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postTypes), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePostType(obj)
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(obj.imgIcon) ? _c('img', {
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": obj.imgIcon,
        "width": "20px",
        "height": "20px",
        "alt": "",
        "aria-hidden": "true"
      }
    }) : _c('v-icon', {
      style: (("color: " + (obj.iconColor || '#616161') + " !important;")),
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(obj.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                                " + _vm._s(_vm._f("platformDisplayName")(obj.type)) + "\n                              ")])], 1)
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.mappedInfluencerData && this.currentUserRole <= _vm.userRoles.AD_STRATEGIST) ? _c('div', [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [(_vm.mappedInfluencerData.tiktokHandle) ? _c('a', {
    attrs: {
      "href": 'https://tiktok.com/' + _vm.mappedInfluencerData.tiktokHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.tiktokHandle))]) : (_vm.mappedInfluencerData.youtubeHandle) ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.mappedInfluencerData.youtubeHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.youtubeHandle))], 1) : (_vm.mappedInfluencerData.linkedinHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.mappedInfluencerData.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.linkedinHandle))], 1) : (_vm.postData.type === 'twitter' || _vm.mappedInfluencerData.twitterHandle) ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + (_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.mappedInfluencerData.instagramHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.instagramHandle))], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.type) ? _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [(_vm.getPostTypeMeta(_vm.postData.type).imgIcon) ? _c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.getPostTypeMeta(_vm.postData.type).imgIcon,
      "width": "15px",
      "height": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('v-icon', {
    staticClass: "mr-1",
    style: (("color: " + (_vm.getPostTypeMeta(_vm.postData.type).iconColor || '#ffffff') + " !important;")),
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.getPostTypeMeta(_vm.postData.type).icon))]), _vm._v("\n                        " + _vm._s(_vm._f("platformDisplayName")(_vm.postData.type)) + "\n                      ")], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "0",
            "padding": "0",
            "margin-left": "-5px"
          },
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', _vm._g({
          staticClass: "ml-2",
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, on), [_vm._v("mdi-chevron-down-circle")])], 1)]
      }
    }], null, false, 970486711)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postTypes), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePostType(obj)
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(obj.imgIcon) ? _c('img', {
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": obj.imgIcon,
        "width": "20px",
        "height": "20px",
        "alt": "",
        "aria-hidden": "true"
      }
    }) : _c('v-icon', {
      style: (("color: " + (obj.iconColor || '#616161') + " !important;")),
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(obj.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                              " + _vm._s(_vm._f("platformDisplayName")(obj.type)) + "\n                            ")])], 1)
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.influencerData) ? _c('v-col', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("\n                      Submitted By:\n                      "), _vm._v(" "), (_vm.influencerData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCutOffView) ? _c('div', [_c('v-row', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "xs": "12"
    }
  }, [_c('v-switch', {
    staticClass: "float-right",
    attrs: {
      "label": "Preview Tiktok"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('tiktok')
      }
    },
    model: {
      value: (_vm.isTikTokCutOff),
      callback: function($$v) {
        _vm.isTikTokCutOff = $$v
      },
      expression: "isTikTokCutOff"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "float-right pr-4",
    attrs: {
      "label": "Preview IG Story"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IGStory')
      }
    },
    model: {
      value: (_vm.isIGStory),
      callback: function($$v) {
        _vm.isIGStory = $$v
      },
      expression: "isIGStory"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "float-right pr-5",
    attrs: {
      "label": "Preview IG Reel"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IG')
      }
    },
    model: {
      value: (_vm.isIGCutOff),
      callback: function($$v) {
        _vm.isIGCutOff = $$v
      },
      expression: "isIGCutOff"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "container--fluid": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.images.length === 0,
      "color": "secondary",
      "icon": "secondary",
      "outlined": ""
    }
  }, [_vm._v("\n                    No Media found for this post.\n                  ")]), _vm._v(" "), (_vm.images !== undefined) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "justify-space-around": ""
    }
  }, _vm._l((_vm.images), function(img, imageIndex) {
    return _c('v-flex', {
      key: img && img.url ? img.url : ("missing-media-" + imageIndex),
      attrs: {
        "md4": "",
        "xs12": ""
      }
    }, [(_vm.isMissingMedia(img)) ? _c('v-card', {
      staticClass: "mb-3",
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "warning",
        "outlined": ""
      }
    }, [_vm._v("\n                          This media file is missing. Edit the draft and upload it again.\n                        ")])], 1) : (img.publicID && img.isvideo) ? _c('v-card', {
      staticClass: "mb-3",
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          videoDownload: true,
          overlay: true,
          overlayType: _vm.overlayType,
          postView: true
        })
      }
    })], 1) : (img.isvideo && img.url.includes('s3-ap-southeast-1')) ? _c('v-card', {
      staticClass: "mb-3",
      staticStyle: {
        "max-width": "258px"
      },
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          videoDownload: true,
          overlay: true,
          overlayType: _vm.overlayType,
          postView: true
        })
      }
    })], 1) : _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [(!img.isvideo) ? _c('v-hover', [(img.publicID) ? _c('div', {
      staticClass: "cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.viewMedia(img)
        }
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          trans: {
            width: 320,
            crop: 'scale'
          },
          overlay: true,
          overlayType: _vm.overlayType
        })
      }
    })], 1) : _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      class: ("elevation-" + (_vm.hover ? 12 : 2)),
      attrs: {
        "src": img.thumbnail || img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      },
      on: {
        "click": function($event) {
          return _vm.viewMedia(img.url, img.video)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (img.isvideo) ? _c('div', {
      staticClass: "elevation-8"
    }, [_c('video', {
      attrs: {
        "id": "previewVideo",
        "width": "100%",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n                            Your browser does not support the video tag.\n                          ")])]) : _vm._e()], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.postData.captionText) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    staticClass: "post-caption-textarea",
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": _vm.captionLabel,
      "counter": ""
    },
    model: {
      value: (_vm.postData.captionText),
      callback: function($$v) {
        _vm.$set(_vm.postData, "captionText", $$v)
      },
      expression: "postData.captionText"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isVideoLink) ? _c('div', [(_vm.postData.vdoLink) ? _c('div', {
    staticClass: "caption-label"
  }, [_vm._v("\n                    Link\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.postData.vdoLink) ? _c('div', {
    staticClass: "caption-text"
  }, [_c('span', {
    staticClass: "caption-text__value"
  }, [_vm._v(_vm._s(_vm.postData.vdoLink))]), _vm._v(" "), (_vm.getVideoLink(_vm.postData.vdoLink)) ? _c('v-btn', {
    attrs: {
      "href": _vm.getVideoLink(_vm.postData.vdoLink),
      "target": "_blank",
      "rel": "noopener noreferrer",
      "icon": "",
      "x-small": "",
      "color": "secondary",
      "title": "Open video link"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isRemark) ? _c('div', {
    staticClass: "body-1"
  }, [_c('div', {
    staticClass: "kobe-remark-display"
  }, [_c('div', {
    staticClass: "kobe-remark-display__label"
  }, [_vm._v("Kobe Remark")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderHTML(_vm.postData.remark))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isHashTag) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Mandatory Hashtag & Mentions",
      "counter": ""
    },
    model: {
      value: (_vm.postData.mandatoryHashtag),
      callback: function($$v) {
        _vm.$set(_vm.postData, "mandatoryHashtag", $$v)
      },
      expression: "postData.mandatoryHashtag"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCallToActionLinks) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Call to Action Links",
      "counter": ""
    },
    model: {
      value: (_vm.postData.callToActionLinks),
      callback: function($$v) {
        _vm.$set(_vm.postData, "callToActionLinks", $$v)
      },
      expression: "postData.callToActionLinks"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [(_vm.postData.postDate) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Scheduled: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.postDate))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.postDateEnd ? ("  to " + (_vm.postData.postDateEnd)) : ''))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postStatusDisplay))])])], 1), _vm._v(" "), (_vm.postData.abuse_resolved || _vm.postData.release_abuse_resolved) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check")]), _vm._v(" "), _c('span', [_vm._v("Abuse Resolved")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.postData.postURL) ? _c('div', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-chip', {
    staticClass: "subtitle-1 ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('v-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('strong', [_c('a', {
    attrs: {
      "href": _vm.postData.postURL,
      "target": "_blink"
    }
  }, [_vm._v("View Live Post")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [(_vm.postData.requestDate) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading-1 ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Request Date: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.requestDate))])])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.requestDate && _vm.postData.propose_dates) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading-1 ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Propose Dates: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.propose_dates.map(function (p) { return p; }).join(', ')))])])], 1) : _vm._e()]), _vm._v(" "), (_vm.proposeDateActions) ? _c('v-card-actions', {
    staticClass: "mt-2",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.overRideBySuperAdmin || (_vm.postData.status === _vm.postStatusConfig.APPROVE && _vm.postData.requestDate)) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openProposeDateDialog()
      }
    }
  }, [_vm._v("\n                    Propose new Dates\n                    "), _c('v-icon', {
    attrs: {
      "small": "",
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "success"
    },
    on: {
      "click": _vm.invokeConfirmDateChange
    }
  }, [_vm._v("\n                    Confirm Date\n                    "), _c('v-icon', {
    attrs: {
      "small": "",
      "float-right": ""
    }
  }, [_vm._v("check")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.influencerActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("\n                    Edit Draft\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.overRideBySuperAdmin ? _vm.overRideBySuperAdmin : _vm.csActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("\n                    Edit Draft\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.editLiveDate()
      }
    }
  }, [_vm._v("\n                    Edit Live Date\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.postData.status !== _vm.postStatusConfig.CLIENT_PENDING && _vm.postData.status !== _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.approve()
      }
    }
  }, [_vm._v("\n                    Submit Draft to AM\n                    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.status >= _vm.postStatusConfig.CLIENT_PENDING && !_vm.postData.metadataTagged) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.markMetadataTag([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                    Mark As Metadata Tagged\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.status >= _vm.postStatusConfig.CLIENT_PENDING && _vm.isIncludeInAbuseReport(_vm.postData._id, _vm.clientReportAbuseData) && !_vm.postData.abuse_resolved && !_vm.postData.release_abuse_resolved) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.abuseResolvePosts([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                    Mark As Abuse Resolved\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.status === _vm.postStatusConfig.AD_STRATEGIST_PENDING && _vm.postData.campaignID && _vm.campaign.campaignType !== _vm.campaignTypes.STORY_TELL) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.directRelease()
      }
    }
  }, [_vm._v("\n                    Direct Release to Client\n                    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.overRideBySuperAdmin ? _vm.overRideBySuperAdmin : _vm.saleActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.postData.abuse_resolved) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.releaseAbuseResolvedPosts([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                    Release to Client\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("done_all")])], 1) : _vm._e(), _vm._v(" "), ((_vm.postData.status === _vm.postStatusConfig.AD_STRATEGIST_PENDING && _vm.postData.waiting_release)) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.release()
      }
    }
  }, [_vm._v("\n                    Release to Client\n                    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.clientReportAbuse.length < 1 && _vm.clientActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.postData.propose_dates && _vm.postData.status === _vm.postStatusConfig.CLIENT_PENDING) ? _c('v-btn', {
    attrs: {
      "color": "indigo",
      "dark": "",
      "to": {
        name: 'posts-submission-review',
        query: {
          id: _vm.postData._id
        }
      }
    }
  }, [_vm._v("Start Submission Review")]) : _vm._e(), _vm._v(" "), (_vm.postData.propose_dates && _vm.postData.status !== _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.openChooseDateDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")]), _vm._v(" Approve Date\n                  ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.cs_inf_chatbox) ? _c('v-flex', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "subtitle-1"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("message")]), _vm._v("\n                          " + _vm._s(_vm.conversationWithName) + " (" + _vm._s(_vm.messages.length) + ")\n                        ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-container', [_c('chat-box', {
    attrs: {
      "label": _vm.commentToLabel,
      "messages": _vm.messages
    },
    on: {
      "commented": _vm.sendMessage
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client_inf_chatbox) ? _c('v-flex', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("message")]), _vm._v("\n                          Internal Notes (for your internal communication only, neither Kobe nor the creators would have access to these notes)\n                        ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-container', [_c('chat-box', {
    attrs: {
      "label": "",
      "messages": _vm.clientMessages,
      "isClient": _vm.isClient,
      "type": "internal_notes"
    },
    on: {
      "commented": _vm.sendClientMessage
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.postReviewApproved) ? _c('v-flex', {
    attrs: {
      "centered": ""
    }
  }, [(_vm.postData.clientAcceptReview) ? _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("Rating on influencer's quality of work")]), _vm._v(" "), _c('v-rating', {
    staticClass: "ma-5",
    attrs: {
      "color": "secondary",
      "size": "30",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.postData.clientAcceptReview.rate),
      callback: function($$v) {
        _vm.$set(_vm.postData.clientAcceptReview, "rate", $$v)
      },
      expression: "postData.clientAcceptReview.rate"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.postData.clientAcceptReview.rate) + "/5 stars Rated")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-1",
    attrs: {
      "max-width": "100"
    }
  }, [_c('p', [_vm._v("Comment for Influencer")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "text": "",
      "filled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.postData.clientAcceptReview.comment),
      callback: function($$v) {
        _vm.$set(_vm.postData.clientAcceptReview, "comment", $$v)
      },
      expression: "postData.clientAcceptReview.comment"
    }
  })], 1)])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), ((_vm.overRideBySuperAdmin || _vm.postAbuseHistory) && _vm.clientReportAbuse.length > 0) ? _c('v-col', {
    attrs: {
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-expansion-panels', {
    staticClass: "report-abuse-section"
  }, _vm._l((_vm.clientReportAbuse), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "subtitle-1",
      attrs: {
        "color": "red lighten-4"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "deep-orange"
      }
    }, [_vm._v("report_problem")]), _vm._v("\n                    Reported Abuse\n                  ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "report-abuse-expansion"
    }, [_c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3 pl-1 pr-1"
    }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
      return _c('li', {
        key: r
      }, [_vm._v(_vm._s(r))])
    }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Abuse:")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "max-height": "300px",
        "min-height": "200px",
        "overflow-y": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderHTML(item.comment))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-xs-right caption font-weight-italic"
    }, [_vm._v(_vm._s(_vm.formatDate(item.date)))]), _vm._v(" "), (item.files) ? _c('div', [_c('h4', [_vm._v("Uploaded Screenshots:")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.files), function(f, index) {
      return _c('li', {
        key: index
      }, [(f.url) ? _c('a', {
        attrs: {
          "href": f.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.utilsFunc.getFileNameFromURL(f.url)))]) : _vm._e()])
    }), 0)])]) : _vm._e()])], 1)], 1)], 1)
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('post-media-viewer-modal', {
    attrs: {
      "viewerValue": _vm.mediaViewerDialog,
      "media": _vm.mediaItem,
      "videoPlayer": _vm.videoPlayer
    },
    on: {
      "closed": _vm.closeMediaViewerModal
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.postData !== null) ? _c('view-post-detail-modal', {
    attrs: {
      "campaignName": _vm.postData.campaignName,
      "submittedCampaignName": _vm.postData.submittedCampaignName,
      "postDetails": _vm.postDetails,
      "postReviewApproved": _vm.postReviewApproved,
      "influencerData": _vm.influencerData,
      "mappedInfluencerData": _vm.mappedInfluencerData,
      "postAbuseHistory": _vm.postAbuseHistory,
      "clientReportAbuse": _vm.clientReportAbuse,
      "detailValue": _vm.viewPostDetailDialog,
      "userObj": _vm.userObj
    },
    on: {
      "detailClosed": _vm.closeDetailModal
    }
  }) : _vm._e(), _vm._v(" "), _c('propose-date-modal', {
    attrs: {
      "post": _vm.postData,
      "proposeDialogValue": _vm.proposeDateDialog
    },
    on: {
      "proposeClosed": _vm.closeProposeDateModal
    }
  }), _vm._v(" "), _c('client-choose-date-modal', {
    attrs: {
      "post": _vm.postData,
      "ChooseDateDialogValue": _vm.chooseDateDialog
    },
    on: {
      "chooseDateClosed": _vm.closeChooseDateModal
    }
  }), _vm._v(" "), _c('v-dialog', {
    ref: "dateDialog",
    attrs: {
      "return-value": _vm.confirmDate,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.confirmDate = $event
      },
      "update:return-value": function($event) {
        _vm.confirmDate = $event
      }
    },
    model: {
      value: (_vm.changeConfirmDate),
      callback: function($$v) {
        _vm.changeConfirmDate = $$v
      },
      expression: "changeConfirmDate"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.post ? _vm.post.postDate : ''
    },
    model: {
      value: (_vm.confirmDate),
      callback: function($$v) {
        _vm.confirmDate = $$v
      },
      expression: "confirmDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.changeConfirmDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.saveConfirmDate
    }
  }, [_vm._v("OK")])], 1)], 1), _vm._v(" "), _c('propose-date-modal', {
    attrs: {
      "post": _vm.postData,
      "proposeDialogValue": _vm.proposeDateDialog
    },
    on: {
      "proposeClosed": _vm.closeProposeDateModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd5cc08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/ViewPostModal.vue
// module id = 2311
// module chunks = 0